// extracted by mini-css-extract-plugin
export default {"container":"gRmzDf","container--inline":"tySy5d"};